import React, {useEffect, useRef} from "react";
import QRCode from "qrcode";
import {Box} from "@mui/material";
import {useLanguage} from "../../contexts/LanguageContext";
import { logger } from "../../store/middleware/consoleEventLogger";
import {useNavigate} from "react-router-dom";
import {getSessionStatus} from "../../services/faceLiveness";

const QRCodeSection = ({sessionId, redirectUrl}) => {
  const {language} = useLanguage();
  const navigate = useNavigate();
  const qrCodeScanInterval = 3000;

  const qrCodeCanvas = useRef(null);

  useEffect(() => {
    const statusToken = sessionStorage.getItem("certage_status_token");
    if (!sessionId || !statusToken || !qrCodeCanvas.current) return;

    const qrCodeUrl = `${window.location.origin}/verification/${encodeURIComponent(sessionId)}?from_qr_code=1&language=${encodeURIComponent(language)}#status_token=${encodeURIComponent(statusToken)}`;

    QRCode.toCanvas(qrCodeCanvas.current, qrCodeUrl, {width: 200, margin: 2}, (error) => {
      if (error) logger.error("QR code generation error:", error);
    });
  }, [sessionId, language]);

  useEffect(() => {
    if (!sessionId) return;

    let interval;

    const fetchStatus = async () => {
      try {
        const response = await getSessionStatus(sessionId);
        const data = response?.data;
        if (!data) return;

        if (data.status === "scanned" || data.status === "started") {
          clearInterval(interval);
          const currentRedirectUrl = response?.data?.redirect_url || redirectUrl;
          navigate("/loading-qr-code", {
            state: {
              sessionId,
              redirectUrl: currentRedirectUrl,
              language
            }
          });
        }
      } catch (err) {
        logger.error("QR polling error:", err);
      }
    };

    // Initial fetch
    fetchStatus();

    // Poll every second
    interval = setInterval(fetchStatus, qrCodeScanInterval);

    return () => clearInterval(interval);
  }, [
    sessionId,
    redirectUrl,
    language,
    navigate
  ]);

  return (
    <Box
      sx={{
        p: 2,
        bgcolor: "white",
        borderRadius: 4,
        boxShadow: "0px 10px 30px rgba(0,0,0,0.1)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <Box
        component="canvas"
        ref={qrCodeCanvas}
        role="img"
        aria-label="QR Code"
        sx={{width: 200, height: 200}}
      />
    </Box>
  );
};

export default QRCodeSection;
